import { db } from '../firebaseInit'
import _ from 'lodash'

export default {
  state: {
    currentView: 'scheduler',
    filterDates: null,
    indexNeededError: false,
    filteredTasks: []
  },
  mutations: {
    setFilterDates (state, payload) {
      state.filterDates = payload
    },
    currentView (state, payload) {
      state.currentView = payload
    },
    indexNeededError (state, payload) {
      state.indexNeededError = payload
    },
    clearFilteredTasks (state) {
      state.filteredTasks = []
    },
    getFilteredTasks (state, payload) {
      state.filteredTasks = payload
    },
    updateFilteredTasks (state, payload) {
      // Convert JS Dates to seconds
      if (payload.start_date && payload.start_date.seconds) {
        payload.start_date = new Date(payload.start_date.seconds * 1000)
      }
      if (payload.due_date && payload.due_date.seconds) {
        payload.due_date = new Date(payload.due_date.seconds * 1000)
      }
      if (payload.completed_date && payload.completed_date.seconds) {
        payload.completed_date = new Date(payload.completed_date.seconds * 1000)
      }
      if (state.filteredTasks && state.filteredTasks.length > 0) {
        let taskIndex = null
        let projectIndex = null
        state.filteredTasks.forEach((project, projectIdx) => {
          let tempIndex = project.tasks.findIndex(i => i.id === payload.id)
          if (tempIndex && tempIndex !== -1) {
            taskIndex = tempIndex
            projectIndex = projectIdx
          }
        })
        let getProject = state.filteredTasks[projectIndex]
        if (state.filteredTasks[projectIndex]) {
          let newTask = { ...state.filteredTasks[projectIndex].tasks[taskIndex], ...payload }
          getProject.tasks.splice(taskIndex, 1, newTask)
          state.filteredTasks.splice(projectIndex, 1, getProject)
        }
      }
    }
  },
  actions: {
    /* eslint-disable quotes */
    async getFilteredTasks ({ commit, getters, dispatch, state }) {    // getters.taskFilters: { type: 'projects/tasks' filterDates: {{ NULL OR NOT NULL }}, filterDateStart: '2017-01-01', filterDateEnd: '2017-01-01', showOnlyMyTasks: true, filterProjects: ['1571862802447-399'], filterProjectType: ['Pre-Construction', 'Construction', 'Completed'], filterPCTofProject: [0, 100], filterTasks: ['1571862802447-399'], filterTaskStatus: ['Not Started', 'Started', 'On Hold', 'Flagged'], filterVendors: [id], filterVendorTypes: 'Decking',  filterBuilders: [ids], filterUsers: [ids]}
      const currentView = state.currentView
      // Set Correct Filters
      const filters = getters.taskFilters[currentView]
      // If Roles = No Projects Viewable
      const roles = getters.roles
      if (roles.projects.view.none) {
        return []
      } else if (roles.projects.view.assigned || roles.projects.view.created) {
        filters.showOnlyMyProjects = true
      }
      // Set Dates if Needed
      let filterStartDate = null
      let filterEndDate = null
      if (filters.filterDates === 'Custom Date Range') {
        filterStartDate = new Date(filters.filterDateStart)
        filterEndDate = new Date(filters.filterDateEnd)
      } else if (filters.filterDates === 'Any Time') {
        filterStartDate = null
        filterEndDate = null
      } else {
        dispatch('dateAdjustmentLogic', filters.filterDates)
        filterStartDate = new Date(getters.filterDates.filterDateStart)
        filterEndDate = new Date(getters.filterDates.filterDateEnd)
      }
      // Get the proper starting "type" table / projects or tasks
      let type = 'projects'
      if (filters.showOnlyMyTasks || filters.filterDoubleBooked) {
        type = 'tasks'
      }
      // Enter Conditions to create the query
      // Either gets ONLY My Tasks -> Then joins to projects -or- Gets Projects then filters additionally later
      // queryString: concats the query string
      function queryString () {
        // If getting ONLY user owned records
        if (type === 'tasks') {
          if (filters.showOnlyMyTasks) {
            let query = null
            if (filters.filterTaskStatus === 'Completed') {
              query = db.collection('tasks').where('deleted', '==', false).where('assigned_to', 'array-contains', getters.user.id)
            } else {
              query = db.collection('tasks').where('deleted', '==', false).where('active', '==', true).where('assigned_to', 'array-contains', getters.user.id)
            }
            return query
          } else if (filters.filterDoubleBooked) {
            let query = db.collection('tasks').where('deleted', '==', false).where('active', '==', true).where('is_double_booked', '==', true)
            return query
          }
        } else if (type === 'projects') {
          let query = null
          if (filters.showOnlyMyProjects) {
            if (filters.includeCompletedProjects) {
              query = db.collection('projects').where('deleted', '==', false).where('assigned_to', 'array-contains', getters.user.id).where('status', '==', 'Completed')
            } else {
              query = db.collection('projects').where('deleted', '==', false).where('assigned_to', 'array-contains', getters.user.id).where('status', '!=', 'Completed')
            }
          } else {
            if (filters.includeCompletedProjects) {
              query = db.collection('projects').where('deleted', '==', false).where('status', '==', 'Completed')
            } else {
              query = db.collection('projects').where('deleted', '==', false).where('status', '!=', 'Completed')
              if (filters.filterProjectTypes) { query = query.where('status', '==', filters.filterProjectTypes) }
            }
          }
          if (filters.filterProjects && filters.filterProjects.length > 0) { query = query.where('id', 'in', filters.filterProjects) }
          return query
        }
      }
      // Async Function to execute a query
      // Runs the query and returns the results
      const executeQuery = async queryString => {
        try {
          const response = await queryString.get()
          return response
        } catch (err) {
          if (String(err).includes('The query requires an index')) {
            commit('indexNeededError', true)
            dispatch('notify', {emails: ['tyler.delange@tessellatech.com'], emailSubject: 'A New Index is Needed', title: 'Create a new index for task filters', message: String(err), url: '/scheduler/filters', icon: null})
            console.log('An Error Getting Query Results', err)
          }
        }
      }
      // Get Queried Results From Filter Variations - Will return projects or tasks
      const queryResults = await executeQuery(queryString())
      if (!queryResults || queryResults.empty) {
        return
      }
      // The Following Logic Gets The Tasks and Associate Projects -or-
      // Gets The Projects
      // ////////// If Getting From TASKS Table //////////////
      // ////////////////////////////////////////////////////
      let tasks = []
      let projects = []
      if (type === 'tasks') {
        // Get Tasks
        queryResults.forEach(taskResponse => {
          const task = taskResponse.data()
          tasks.push({
            id: task.id,                                       // <- Edit Here For Task Fields (And Also Below)
            projectId: task.projectId,
            name: task.name,
            start_date: task.start_date && task.start_date.seconds ? new Date(task.start_date.seconds * 1000) : null,
            due_date: new Date(task.due_date.seconds * 1000),
            status: task.status,
            phase: task.phase,
            assigned_to: task.assigned_to,
            vendor_id: task.vendor_id,
            is_double_booked: task.is_double_booked,
            after_task: task.after_task,
            type: task.type
          })
        })
        // Discard "Not Applicable" tasks
        tasks = tasks.filter(f => f.status !== 'Not Applicable')
        // Get Cooresponding Projects
        const projectIds = _.uniq(tasks.map(m => m.projectId))
        projectIds.forEach(projectId => {
          db.collection('projects').doc(projectId).get().then(projectResponse => {
            const project = { ...projectResponse.data(), id: projectResponse.id }
            if (!project.revertedToLeads) {
              const subTasks = tasks.filter(f => f.projectId === projectId)
              projects.push({
                id: project.id,                               // <- Edit Here For Project Fields (And Also Below)
                name: project.name,
                start_date: new Date(project.start_date.seconds * 1000),
                status: project.status,
                builder: project.builder,
                job_number: project.job_number,
                address: project.address,
                city: project.city,
                state: project.state,
                zip: project.zip,
                assigned_to: project.assigned_to,
                waiting_on_template: project.waiting_on_template,
                tasks: subTasks
              })
            }
          }).then(() => {
            filterResults()
          })
        })
      // ////////// If Getting From PROJECTS Table //////////////
      // ///////////////////////////////////////////////////////
      } else if (type === 'projects') {
        queryResults.forEach(projectResponse => {
          const project = { ...projectResponse.data(), id: projectResponse.id }
          if (!project.revertedToLeads) {
            let subTasks = []
            if (project.tasks) {
              const taskKeys = Object.keys(project.tasks)
              taskKeys.forEach(key => {
                const task = project.tasks[key]
                subTasks.push({
                  id: key,                                      // <- Edit Here For Task Fields
                  projectId: project.id,
                  name: task.name,
                  start_date: task.start_date && task.start_date.seconds ? new Date(task.start_date.seconds * 1000) : null,
                  due_date: new Date(task.due_date.seconds * 1000),
                  status: task.status,
                  phase: task.phase,
                  assigned_to: task.assigned_to,
                  vendor_id: task.vendor_id,
                  is_double_booked: task.is_double_booked,
                  after_task: task.after_task,
                  type: task.type
                })
              })
              // Discard "Not Applicable" tasks
              subTasks = subTasks.filter(f => f.status !== 'Not Applicable')
            }
            projects.push({
              id: project.id,                                // <- Edit Here For Project Fields (And Also Below)
              name: project.name,
              start_date: new Date(project.start_date.seconds * 1000),
              status: project.status,
              builder: project.builder,
              job_number: project.job_number,
              address: project.address,
              city: project.city,
              state: project.state,
              zip: project.zip,
              assigned_to: project.assigned_to,
              waiting_on_template: project.waiting_on_template,
              tasks: subTasks
            })
          }
        })
        filterResults()
      }
      // // Apply Filters To Projects and Tasks
      // // Note that these filters may be redundant from the query but to makes sure they are applied, they are applied again
      function filterResults () {
        // // Calculate Project Percentage, Open / Completed / PastDue Tasks
        projects.forEach((project, index) => {
          let completed = 0
          let open = 0
          let pastDue = 0
          project.tasks.forEach(task => {
            const phase = currentView === 'construction' ? 'Construction' : 'Pre-Construction'
            if (task.type === phase) {
              if (task.status === 'Completed') {
                completed++
              } else if (task.status !== 'Completed' && task.due_date < new Date()) {
                pastDue++
                open++
              } else {
                open++
              }
            }
          })
          projects[index].progress = project.type === 'Completed' ? 100 : completed === 0 ? 0 : open === 0 && completed > 0 ? 100 : Math.floor((completed / (open + completed)) * 100)
          projects[index].pastDueTasks = pastDue
          projects[index].completedTasks = completed
          projects[index].openTasks = open
        })
        // // Get Vendor Type Names if Needed
        let vendorTypeList = []
        if (filters.filterVendorTypes && filters.filterVendorTypes.length > 0) {
          const vendorList = getters.vendorList
          vendorList.forEach(vendor => {
            vendor.vendor_type.forEach(type => {
              if (filters.filterVendorTypes.includes(type)) {
                vendorTypeList.push(vendor.id)
              }
            })
          })
        }
        if (filters.showOnlyMyTasks) projects = projects.map((project) => { return {...project, tasks: project.tasks.filter((task) => task.assigned_to && task.assigned_to.includes(getters.user.id))} })
        if (filters.filterProjects && filters.filterProjects.length > 0) projects = projects.filter(f => filters.filterProjects.includes(f.id))
        if (!_.isEqual(filters.filterPCTofProject, [0, 100])) projects = projects.filter(f => f.progress >= filters.filterPCTofProject[0] && f.progress <= filters.filterPCTofProject[1])
        if (filters.filterProjectTypes && !filters.includeCompletedProjects) projects = projects.filter(f => f.status === filters.filterProjectTypes)
        if (filters.filterProjectTypes && !filters.includeCompletedProjects) projects = projects.map((project) => { return {...project, tasks: project.tasks.filter((task) => task.type === filters.filterProjectTypes)} })
        if (filters.filterProjectPhases && filters.filterProjectPhases.length > 0) projects = projects.map((project) => { return {...project, tasks: project.tasks.filter((task) => filters.filterProjectPhases.includes(task.phase))} })
        if (filters.filterTasks && filters.filterTasks.length > 0) projects = projects.map((project) => { return {...project, tasks: project.tasks.filter((task) => filters.filterTasks.includes(task.name))} })
        if (filters.filterTaskStatus && filters.filterTaskStatus.length > 0) projects = projects.map((project) => { return {...project, tasks: project.tasks.filter((task) => filters.filterTaskStatus.includes(task.status))} })
        if (filters.filterVendors && filters.filterVendors.length > 0) projects = projects.map((project) => { return {...project, tasks: project.tasks.filter((task) => filters.filterVendors.includes(task.vendor_id))} })
        if (vendorTypeList && vendorTypeList.length > 0) projects = projects.map((project) => { return {...project, tasks: project.tasks.filter((task) => vendorTypeList.includes(task.vendor_id))} })
        if (filters.filterBuilders && filters.filterBuilders.length > 0) projects = projects.filter(f => filters.filterBuilders.includes(f.builder))
        if (filters.filterUsers && filters.filterUsers.length > 0) projects = projects.map((project) => { return {...project, tasks: project.tasks.filter((task) => task.assigned_to ? filters.filterUsers.some(s => task.assigned_to.includes(s)) : null)} })
        if (filterStartDate && filterEndDate) projects = projects.map((project) => { return {...project, tasks: project.tasks.filter((task) => task.due_date >= filterStartDate && task.due_date <= filterEndDate)} })
        if (filters.filterUserProjects && filters.filterUserProjects.length > 0) projects = projects.filter(f => filters.filterUserProjects.some(s => f.assigned_to.includes(s)))
        // Only Include Projects WITH Tasks UNLESS they are waiting on a task list (If no filters are selected)
        if (!_.isEqual(filters.filterPCTofProject, [0, 100] && filters.filterPCTofProject[0] === 0) && !filters.filterProjectPhases && !filters.filterTasks && !filters.filterTaskStatus && !filters.filterVendors && !filters.filterVendorTypes && !filters.filterUsers) {
          projects = projects.filter(project => (project.tasks !== undefined && project.tasks.length > 0) || project.waiting_on_template)
        } else {
          projects = projects.filter(project => (project.tasks !== undefined && project.tasks.length > 0))
        }
        commit('getFilteredTasks', projects)
      }
    },
    dateAdjustmentLogic ({ commit }, filterDates) {
      const startDate = new Date()
      const endDate = new Date()
      let filterDateStart = null
      let filterDateEnd = null
      if (filterDates === 'Any Time') {
        filterDateStart = null
        filterDateEnd = null
      } else if (filterDates === '12 Month Range') {
        const getStartDate = new Date(startDate.setMonth(startDate.getMonth() - 6))
        const getEndDate = new Date(endDate.setMonth(endDate.getMonth() + 6))
        filterDateStart = new Date(getStartDate.getFullYear(), getStartDate.getMonth(), 1).toISOString().substr(0, 10)
        filterDateEnd = new Date(getEndDate.getFullYear(), getEndDate.getMonth() + 1, 0).toISOString().substr(0, 10)
      } else if (filterDates === '6 Month Range') {
        const getStartDate = new Date(startDate.setMonth(startDate.getMonth() - 3))
        const getEndDate = new Date(endDate.setMonth(endDate.getMonth() + 3))
        filterDateStart = new Date(getStartDate.getFullYear(), getStartDate.getMonth(), 1).toISOString().substr(0, 10)
        filterDateEnd = new Date(getEndDate.getFullYear(), getEndDate.getMonth() + 1, 0).toISOString().substr(0, 10)
      } else if (filterDates === 'This Month') {
        filterDateStart = new Date(startDate.getFullYear(), startDate.getMonth(), 1).toISOString().substr(0, 10)
        filterDateEnd = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0).toISOString().substr(0, 10)
      } else if (filterDates === 'This Year') {
        filterDateStart = new Date(new Date().getFullYear(), 0, 1).toISOString().substr(0, 10)
        filterDateEnd = new Date(new Date().getFullYear(), 11, 31).toISOString().substr(0, 10)
      } else if (filterDates === 'Last 6 Months') {
        const getDate = new Date(startDate.setMonth(startDate.getMonth() - 6))
        filterDateStart = new Date(getDate.getFullYear(), getDate.getMonth(), 1).toISOString().substr(0, 10)
        filterDateEnd = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0).toISOString().substr(0, 10)
      } else if (filterDates === 'Last 12 Months') {
        const getDate = new Date(startDate.setMonth(startDate.getMonth() - 12))
        filterDateStart = new Date(getDate.getFullYear(), getDate.getMonth(), 1).toISOString().substr(0, 10)
        filterDateEnd = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0).toISOString().substr(0, 10)
      }
      commit('setFilterDates', { filterDates, filterDateStart, filterDateEnd })
    },
    clearFilteredTasks ({ commit }) {
      commit('clearFilteredTasks')
    },
    updateFilteredTasks ({ commit, getters, state }, payload) { // payload: task object
      if (state.filteredTasks && state.filteredTasks.length > 0) {
        commit('updateFilteredTasks', payload)
      }
    }
  },
  getters: {
    currentView (state) {
      return state.currentView
    },
    filterDates (state) {
      return state.filterDates
    },
    indexNeededError (state) {
      return state.indexNeededError
    },
    filteredTasks (state) {
      return state.filteredTasks
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/global.js